import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReconcileHtmlLinkDirective } from './reconcile-html-link.directive';

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [ReconcileHtmlLinkDirective],
  exports: [ReconcileHtmlLinkDirective],
})
export class ReconcileHtmlLinkModule {}
